import { TIconProps } from "./iconProps";

const DotArrowLeft = ({ fontSize = 24, className }: TIconProps) => {
  return (
    <svg width="17" height="14" viewBox="0 0 17 14" fill="none">
      <g opacity="0.24">
        <rect
          width="4"
          height="4"
          rx="2"
          transform="matrix(-1 0 0 1 17 5)"
          fill="black"
          fillOpacity={0.66}
        />
      </g>
      <g opacity="0.24">
        <rect
          width="4"
          height="4"
          rx="2"
          transform="matrix(-1 0 0 1 11 5)"
          fill="black"
          fillOpacity={0.66}
        />
      </g>
      <rect
        width="5"
        height="5"
        rx="2.5"
        transform="matrix(-1 0 0 1 5 4.5)"
        fill="black"
      />
      <rect
        width="3"
        height="3"
        rx="1.5"
        transform="matrix(-1 0 0 1 7.5 0)"
        fill="black"
      />
      <rect
        width="3"
        height="3"
        rx="1.5"
        transform="matrix(-1 0 0 1 7.5 11)"
        fill="black"
      />
    </svg>
  );
};

export default DotArrowLeft;
